/** The part of a query that a retry reads. Every domain query hook returns it. */
export interface RetryableQuery {
    error: unknown;
    /** Required: without it a retry reads as idle and Try again stays enabled while it runs. */
    isFetching: boolean;
    refetch: () => unknown;
}

export interface RetryProps {
    onRetry: () => void;
    isRetrying: boolean;
}

/**
 * `onRetry` and `isRetrying` for SomethingHappened over the queries an error state stands for.
 * Only the failed ones are refetched, so a retry does not reload what already arrived.
 */
export function retryFailedQueries(...queries: RetryableQuery[]): RetryProps {
    return {
        onRetry: () => {
            for (const query of queries) {
                if (query.error) {
                    void query.refetch();
                }
            }
        },
        isRetrying: queries.some((query) => query.isFetching === true),
    };
}
